import type {
  TestCredentialsRequest,
  TestCredentialsResponse,
} from "../types/connectivity";

export async function testPmsCredentials(
  apiBaseUrl: string,
  token: string,
  hotelCode: string,
  body: TestCredentialsRequest
): Promise<TestCredentialsResponse> {
  if (!apiBaseUrl) {
    throw new Error(
      "API base URL is not configured. Please contact support."
    );
  }

  const res = await fetch(
    `${apiBaseUrl}/v1/connectivity/credentials/test`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "hotel-code": hotelCode,
      },
      body: JSON.stringify(body),
    }
  );

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(
      (err as { message?: string }).message ?? `HTTP ${res.status}`
    );
  }

  return res.json() as Promise<TestCredentialsResponse>;
}
